<template>
  <button type="button" class="w-[3.6rem] h-[3.6rem] p-0 bg-[#1f1f1f] text-white text-[1.8rem] font-semibold flex items-center justify-center rounded-full border border-white/20">
    x
  </button>
</template>

<script>

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CloseButton',
  props: {

  }
});
</script>

<style scoped>

</style>
